import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dfe8856"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, watch, PropType } from 'vue';

import DoctorInfo from '@/components/forms/doctor/DoctorInfo.vue';
import { Doctor } from '@/interfaces/Doctor';
import Fieldset from 'primevue/fieldset';


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorForm',
  props: {
  modelValue: {
    type: Object as PropType<Doctor>,
    default: () => ({})
  }
},
  emits: ['update:formValidationChangeState'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const thisDoctor = ref<Doctor>(props.modelValue || ({} as Doctor));

const onFormValidationChangeState = (newValue) => {
  emit('update:formValidationChangeState', newValue);
};

watch(
  () => props.modelValue,
  (newValue) => {
    thisDoctor.value = newValue;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Fieldset), {
      legend: "Detalii generale",
      pt: {
      legend: {
        style: 'padding: 0.75rem !important;'
      }
    }
    }, {
      default: _withCtx(() => [
        _createVNode(DoctorInfo, {
          modelValue: thisDoctor.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisDoctor).value = $event)),
          "onUpdate:formValidationChangeState": onFormValidationChangeState
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _hoisted_1
  ], 64))
}
}

})